import { logger } from '../../../../utils/common/logger'
import { DOMUtils } from '../../../../utils/dom'
import { Store } from '../../../../utils/storage/keys'
import { LocalStore } from '../../../../utils/storage/local'
import { IdentityEvent } from '../../../common/events/identity'
import { IProfile } from '../../../common/profile'

export interface IWindow extends Window {
    optable: any
}
declare let window: IWindow

const OPTABLE_URL='https://postmedia.solutions.cdn.optable.co/public-assets/postmedia-sdk.js'

export class Optable {
    public initialize(slug: string): void {
        // load the Optable SDK
        window.optable=window.optable||{cmd:[]}
        window.optable.site=slug
        DOMUtils.loadScript(OPTABLE_URL)

        // identify the user
        const profile = LocalStore.get<IProfile>(Store.ID)
        if (profile && profile.email) {
            window.optable.cmd.push(() => {
                window.optable.postmedia_instance.identify(window.optable.SDK.eid(profile.email))
                    .then(() => logger('debug', 'Optable identify eid success'))
            })
        }
        // add event listeners for fullcontact identify
        document.addEventListener(IdentityEvent.SET_PERSON_ID, (e: any) => {
            window.optable.cmd.push(() => {
                if (e.detail.pid) {
                    window.optable.postmedia_instance.identify(window.optable.SDK.cid(e.detail.pid))
                        .then(() => logger('debug', 'Optable identify cid success'))
                }
            })
        })
    }
}
